import type React from 'react'
import { useState } from 'react'

import css from './styles.module.css'

interface Props {
  title: string
  value: string
  onChange: (value: string) => void
}

const EMPTY_ERROR = 'This field cannot be empty'
export const InputRow: React.FC<Props> = ({ onChange, value, title }) => {
  // todo: use storybook input component, remove internal state and hardcoded error
  const [state, setState] = useState(value)
  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { value: next } = ev.target

    setState(next)
    if (next) {
      onChange(next)
    }
  }

  return (
    <div className={css.input_row}>
      <div className={css.title}>{title}</div>
      <div className={css.input_wrapper}>
        <input
          type="text"
          value={state}
          className={css.input}
          onChange={handleChange}
        />
        {!state && <span className={css.error}>{EMPTY_ERROR}</span>}
      </div>
    </div>
  )
}
